import { useState, useCallback, useEffect, useRef } from 'react';

export const useTextToSpeech = () => {
  const [isSpeaking, setIsSpeaking] = useState(false);
  const synth = window.speechSynthesis;
  const voicesRef = useRef([]);

  // Stimmen laden (Browser laden diese asynchron)
  const loadVoices = useCallback(() => {
    voicesRef.current = synth.getVoices();
  }, [synth]);

  useEffect(() => {
    loadVoices();
    if (synth.onvoiceschanged !== undefined) {
      synth.onvoiceschanged = loadVoices;
    }
    return () => synth.cancel();
  }, [loadVoices, synth]);

  const speak = useCallback((text, langCode = 'de') => {
    console.log ("Speechlang selected src: " + langCode);
    if (!('speechSynthesis' in window)) return;

    synth.cancel();
    if (!text) return;

    const utterance = new SpeechSynthesisUtterance(text);
    
    // Normalisiere Sprachcode (z.B. "en-US" -> "en")
    const lang = langCode.split('-')[0].toLowerCase();
    const targetLang = lang === 'de' ? 'de' : 'en';

    console.log ("Setting speech lang: " + targetLang);

    // Suche die beste verfügbare Stimme für die Zielsprache
    // Wir filtern die Stimmenliste nach dem Sprachkürzel
    const availableVoices = voicesRef.current.filter(v => 
      v.lang.startsWith(targetLang)
    );

    if (availableVoices.length > 0) {
      // Priorität: Suche nach einer Stimme, die "Google" oder "Siri" im Namen hat (meist bessere Qualität)
      const premiumVoice = availableVoices.find(v => 
        v.name.includes('Google') || v.name.includes('Siri') || v.name.includes('Premium')
      );
      utterance.voice = premiumVoice || availableVoices[0];
    }

    // Setze explizit den Sprachcode für die Engine
    utterance.lang = targetLang === 'de' ? 'de-DE' : 'en-US';
    
    utterance.onstart = () => setIsSpeaking(true);
    utterance.onend = () => setIsSpeaking(false);
    utterance.onerror = () => setIsSpeaking(false);

    synth.speak(utterance);
  }, [synth]);

  const stop = useCallback(() => {
    synth.cancel();
    setIsSpeaking(false);
  }, [synth]);

  return { speak, stop, isSpeaking };
};